module.exports = __webpack_public_path__ + "img/1549274176.c4c61fa5.jpg";